import axios from 'axios';
import { getConfig } from 'configs';
import { RcFile } from 'antd/lib/upload';

const API_PATH = '/xapi/v1/enquiry/document';

interface EnquiryDocumentUploadData {
  documents: (RcFile | undefined)[];
  referenceNo: string;
  enquiryFlag?: string;
}

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');
const uploadFile = async (
  file: File | RcFile | undefined,
  referenceNo: string,
  index: number,
  isLast: boolean,
  accessToken: string,
  enquiryFlag?: string,
) => {
  if (!file) return;
  const options = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'multipart/form-data',
    },
  };

  const formData = new FormData();
  formData.append('file', file);
  //Thuy's Note: have to use await because of 'isLast'
  await axios({
    method: 'post',
    url: config.baseApiUrl + API_PATH,
    data: formData,
    params: { referenceNo, index, isLast, enquiryFlag },
    headers: options.headers,
  });
};

export const uploadFiles = async ({
  accessToken,
  params,
}: {
  accessToken: string;
  params: EnquiryDocumentUploadData;
}) => {
  const { documents, referenceNo, enquiryFlag } = params;

  // Note(Andy Chow): Please refer to https://bitbucket.org/generali-hk/all-in-one-web-app/pull-requests/700 for the implementation details
  const responses = documents?.map((d, i) => {
    const isLast = i === documents.length - 1;
    if (!isLast) {
      return uploadFile(d, referenceNo, i + 1, isLast, accessToken, enquiryFlag);
    }
  });

  return await Promise.all(responses)
    .then(() => {
      const lastDocument = documents[documents.length - 1];
      return uploadFile(lastDocument, referenceNo, documents.length, true, accessToken, enquiryFlag);
    })
    .catch((error) => {
      throw error;
    });
};
